module.exports = __webpack_public_path__ + "img/poetsinstructie.18d7ed84.jpg";